<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import DefaultMenu from "@/views/Layout/Menus/DefaultMenu";
import ProjectsMenu from "@/views/Layout/Menus/ProjectsMenu";
import MenuAssetMgmt from "./Menus/MenuAssetMgmt";
import MenuDevelopment from "./Menus/MenuDevelopment";
import MenuInvIntMgmt from "./Menus/MenuInvIntMgmt";

import { mapGetters } from "vuex";
import { EventBus } from "@/libraries/EventBus";
import VTilesMenu from "@/components/Tiles/VTilesMenu";

function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
    if (hasElement(className)) {
        new PerfectScrollbar(`.${className}`);
    } else {
        // try to init it later in case this component is loaded async
        setTimeout(() => {
            initScrollbar(className);
        }, 100);
    }
}

import DashboardNavbar from "./DefaultNavbar";
import ContentFooter from "./DefaultFooter";

export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        DefaultMenu,
        ProjectsMenu,
        VTilesMenu,
        MenuAssetMgmt,
        MenuDevelopment,
        MenuInvIntMgmt
    },
    data() {
        return {
            overrideMenu: "",
            showTileMenu: false
        };
    },
    computed: {
        ...mapGetters("auth", ["getAuthUser"]),
        expectedMenu() {
            if (this.overrideMenu !== "") {
                return this.overrideMenu;
            }
            // return "default";
            if (
                "invoice_setup" in this.getAuthUser &&
                this.getAuthUser.invoice_setup == "projects"
            ) {
                return "projects";
            } else {
                return "default";
            }
        },
        dynamicMenu() {
            return this.getAuthUser.tiles_config.menu;
            return "menu-asset-mgmt";
            return "menu-inv-int-mgmt";
            return "menu-development";
        }
    },
    created() {
        EventBus.$on("menu-change", this.changeMenu);
        EventBus.$on("tiles-open", this.handleTiles);
        this.initScrollbar();
    },
    beforeDestroy() {
        EventBus.$off("menu-change", this.changeMenu);
        EventBus.$off("tiles-open");
    },
    methods: {
        handleTiles() {
            this.showTileMenu = true;
        },
        changeMenu(to) {
            this.overrideMenu = to;
            this.$nextTick(() => {
                this.initScrollbar();
            });
        },
        initScrollbar() {
            let docClasses = document.body.classList;
            let isWindows = navigator.platform.startsWith("Win");
            initScrollbar("scrollbar-inner");
            //docClasses.add("perfect-scrollbar-on");

            if (isWindows) {
                // if we are on windows OS we activate the perfectScrollbar function
                initScrollbar("scrollbar-inner");

                docClasses.add("perfect-scrollbar-on");
            } else {
                docClasses.add("perfect-scrollbar-off");
            }
        }
    }
};
</script>

<template>
    <div class="wrapper">
        <notifications></notifications>

        <!-- Menu area -->
        <template v-if="$isDE">
            <default-menu v-if="expectedMenu === 'default'" />
            <projects-menu v-else-if="expectedMenu === 'projects'" />
        </template>
        <template v-else>
            <component :is="dynamicMenu"></component>
        </template>

        <div class="main-content">
            <dashboard-navbar></dashboard-navbar>
            <div @click="$sidebar.displaySidebar(false)">
                <transition name="router" mode="out-in">
                    <!-- your content here -->
                    <router-view :key="$route.path"></router-view>
                </transition>
            </div>

            <transition name="fade">
                <portal-target name="modals"></portal-target>
            </transition>
            <transition name="fade">
                <portal-target name="shortcut-modal"></portal-target>
            </transition>
            <transition name="fade">
                <portal-target name="queue"></portal-target>
            </transition>

            <v-tiles-menu v-if="showTileMenu" @close="showTileMenu = false" />

            <content-footer v-if="!$route.meta.hideFooter"></content-footer>
        </div>
    </div>
</template>
